import { useState, useEffect } from 'react';
import { useMediaQuery } from './useMediaQuery';
import { reducedMotion as reducedMotionQuery } from '../ui/theme/media';

const GLITCH_CHARS = '▒▓░█▌▐▀▄■□◆◇○●';

function scramble(text: string, resolvedCount: number): string {
  return text
    .split('')
    .map((ch, i) => {
      if (ch === ' ') return ' ';
      if (i < resolvedCount) return ch;
      return GLITCH_CHARS[Math.floor(Math.random() * GLITCH_CHARS.length)];
    })
    .join('');
}

export function useGlitchLabel(
  text: string,
  active: boolean,
  resolvedRatio = 0.5,
  intervalMs = 120
): string {
  const prefersReducedMotion = useMediaQuery(reducedMotionQuery);
  const resolvedCount = Math.floor(text.length * resolvedRatio);

  const animating = active && !prefersReducedMotion;
  const [display, setDisplay] = useState(() => (animating ? scramble(text, resolvedCount) : text));

  // 켜질 때·글자가 바뀔 때의 첫 장면 — effect 가 아니라 렌더 중에 섞는다.
  const [scrambledFor, setScrambledFor] = useState<{ text: string; resolvedCount: number } | null>(
    animating ? { text, resolvedCount } : null
  );
  if (
    animating &&
    (scrambledFor === null ||
      scrambledFor.text !== text ||
      scrambledFor.resolvedCount !== resolvedCount)
  ) {
    setScrambledFor({ text, resolvedCount });
    setDisplay(scramble(text, resolvedCount));
  } else if (!animating && scrambledFor !== null) {
    setScrambledFor(null);
  }

  useEffect(() => {
    if (!animating) return;
    const id = setInterval(() => {
      setDisplay(scramble(text, resolvedCount));
    }, intervalMs);
    return () => clearInterval(id);
  }, [animating, text, resolvedCount, intervalMs]);

  if (!active) return text;
  if (prefersReducedMotion) return text.slice(0, resolvedCount) + '...';
  return display;
}
